import initSponsoredBanners from '../objects/homepage/sponsored-banners';

initSponsoredBanners();
